/**
 * AxiEditor HTML → 저장할 HTML (2026-10-14). tiptap 쪽 `serializeForSave` 와 **같은 꼴**을 돌려준다.
 *
 * - 그림 주소가 우리 영구 주소(`/api/v1/files/<id>/image`)면 `data-file-id` 를 붙인다 —
 *   9-23 에 정한 «그림의 오래 사는 참조»다(읽기 화면·재편집이 이 칸을 쓴다).
 *   AxiEditor 의 `uploadHandler` 가 처음부터 영구 주소를 돌려주므로(presigned 를 거치지 않는다)
 *   src 를 갈 일은 없고 표식만 단다.
 * - 아직 올라가지 않은 그림을 센다 — 저장을 막아야 한다:
 *   `data-axe-pending`(4.0 · 3.x 는 `data-open-axe-pending` — 올리는 중이거나 실패해 다시 올릴 수 있게 남긴 것) · `blob:` → 올리는 중
 *   `data:` → 실패(서버가 data: 를 지워 «조용히» 사라진다)
 * - 끝으로 `sanitizeBoardHtmlRich` 를 거친다(두 겹 중 앞 겹 — 뒷 겹은 서버 `sanitizeBoardBodyRich`).
 */

import { FILE_ID_ATTR, type SerializedForSave } from '../editor-html';
import { sanitizeBoardHtmlRich } from './sanitize-board-rich';

const OUR_IMAGE_SRC = /^\/api\/v1\/files\/([^/?#]+)\/image(?:[?#].*)?$/;

/** AxiEditor `uploadHandler` 가 돌려준 주소에서 파일 id 를 읽는다. 우리 주소가 아니면 null. */
export function fileIdFromImageSrc(src: string): string | null {
  const m = OUR_IMAGE_SRC.exec(src);
  return m?.[1] ? decodeURIComponent(m[1]) : null;
}

export function serializeAxiForSave(html: string): SerializedForSave {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  let failedCount = 0;
  let uploadingCount = 0;

  for (const el of Array.from(doc.querySelectorAll('img'))) {
    const src = el.getAttribute('src') ?? '';
    if (el.hasAttribute('data-axe-pending') || el.hasAttribute('data-open-axe-pending') || /^blob:/i.test(src)) { uploadingCount += 1; continue; }
    if (/^data:/i.test(src)) { failedCount += 1; continue; }
    const fileId = fileIdFromImageSrc(src);
    if (fileId) el.setAttribute(FILE_ID_ATTR, fileId);
  }

  return { html: sanitizeBoardHtmlRich(doc.body.innerHTML), failedCount, uploadingCount };
}
